import { render } from "./ProductListPage.vue?vue&type=template&id=4cec9618&scoped=true&ts=true"
import script from "./ProductListPage.vue?vue&type=script&lang=ts"
export * from "./ProductListPage.vue?vue&type=script&lang=ts"

import "./ProductListPage.vue?vue&type=style&index=0&id=4cec9618&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cec9618"]])

export default __exports__